<template>
  <div class="about-detail-container">
    <architecture v-if="moduleId === MODULE_CONFIG.ARCHITECTURE"/>
    <building v-if="moduleId === MODULE_CONFIG.BUILDING"/>
    <bylaws v-if="moduleId === MODULE_CONFIG.BYLAWS"/>
    <contact v-if="moduleId === MODULE_CONFIG.CONTACT"/>
    <honor v-if="moduleId === MODULE_CONFIG.HONOR"/>
    <mechanism v-if="moduleId === MODULE_CONFIG.MECHANISM"/>
    <volunteer v-if="moduleId === MODULE_CONFIG.VOLUNTEER"/>
  </div>
</template>

<script>
/* eslint-disable */
import { MODULE_CONFIG } from '@/config/index'

import architecture from './architecture'
import building from './building'
import bylaws from './bylaws'
import contact from './contact'
import honor from './honor'
import mechanism from './mechanism'
import volunteer from './volunteer'

export default {
  components: {
    architecture,
    building,
    bylaws,
    contact,
    honor,
    mechanism,
    volunteer
  },

  data() {
    return {
      moduleId: '',
      MODULE_CONFIG
    }
  },
  methods: {
    

  },

  watch: {
    $route(newVal) {
      const { id } = newVal.params
      this.moduleId = Number(id)
    }
  },

  created() {
    console.log(this.$route)
    const { id } = this.$route.params
    this.moduleId = Number(id)
  }
}
</script>

<style lang="scss">
.about-detail-container {


}
</style>
